module.exports = __webpack_public_path__ + "static/media/Rebak Doors (7).568c1c71.JPG";